import { render } from "./ReviewAttachmentsWidget.vue?vue&type=template&id=d67c43e0&ts=true"
import script from "./ReviewAttachmentsWidget.ts?vue&type=script&lang=ts&external"
export * from "./ReviewAttachmentsWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__